import _ from 'lodash';
import { helperGetApiRouteById } from 'helpers/ApiHelper';
import { PROMO_TYPE_GALLERY } from 'screens/SeriesDetail/SeriesDetailHelpers';

export function getGalleryAPIUrl(tabUrl) {
  let contentId = _.split(tabUrl, '/').pop();
  contentId = _.split(contentId, '-').pop();
  return helperGetApiRouteById('screenpanels', contentId, '{panelId}');
}

export function showLoader(panel) {
  const panelType = _.get(panel, 'panelType');
  return !panel || panelType !== PROMO_TYPE_GALLERY;
}
